// Offene Stellen DNA Automotive GmbH (deutschsprachig – Zielgruppe lokale Bewerber)
export const JOBS_EMAIL = "info@dna-automotive.de";

export const EMPLOYER_INTRO =
  "Wir sind ein modernes Automobilunternehmen mit Schwerpunkt auf hochwertigen Fahrzeugen, Premiumfahrzeugen und Sportwagen. Neben dem Fahrzeughandel gehören unter anderem Finanzierung, Leasing, Fahrzeugankauf, Inzahlungnahme, Fuhrparkmanagement, Fahrzeugbeschaffung, Zulassungsservice und weitere Dienstleistungen rund um das Automobil zu unserem Tagesgeschäft. Wir möchten unser Team weiter ausbauen und suchen engagierte Mitarbeiterinnen und Mitarbeiter, die gemeinsam mit uns wachsen möchten.";

export const BENEFITS = [
  "Modernes, professionelles Arbeitsumfeld in der MotorWorld Köln-Rheinland",
  "Interessante und abwechslungsreiche Premiumfahrzeuge und Sportwagen",
  "Kurze Entscheidungswege und flache Hierarchien",
  "Eigenverantwortliches Arbeiten mit echtem Gestaltungsspielraum",
  "Junges und dynamisches Unternehmen",
  "Entwicklungsmöglichkeiten und langfristige Zusammenarbeit",
  "Leistungsgerechte Vergütung",
  "Die Möglichkeit, aktiv am weiteren Wachstum von DNA Automotive mitzuwirken",
];

export const JOBS = [
  {
    slug: "automobilverkaeufer",
    title: "Automobilverkäufer (m/w/d)",
    employmentType: "Vollzeit",
    department: "Verkauf",
    location: "Köln",
    meta: ["Vollzeit", "Verkauf", "Köln"],
    teaser: "Beratung und Verkauf hochwertiger Premiumfahrzeuge und Sportwagen im Herzen der MotorWorld Köln-Rheinland.",
    tasks: [
      "Beratung und Verkauf hochwertiger Premiumfahrzeuge und Sportwagen",
      "Betreuung und aktiver Ausbau unseres bestehenden Kundenstamms",
      "Professionelle Fahrzeugpräsentation im Showroom der MotorWorld Köln-Rheinland",
      "Erstellung individueller Angebote inklusive Finanzierungs- und Leasingoptionen",
      "Fahrzeugmanagement: Bestandspflege, Inserate und Fahrzeugdaten",
      "Abwicklung von Fahrzeugankäufen und Inzahlungnahmen",
      "Begleitung von Probefahrten und Fahrzeugübergaben",
      "Pflege der Fahrzeugpräsentation – online und vor Ort",
      "Enge Zusammenarbeit mit unseren Finanzierungspartnern",
    ],
    profile: [
      "Abgeschlossene kaufmännische oder automobile Ausbildung",
      "Erfahrung im Automobilverkauf von Vorteil",
      "Sicheres, gepflegtes und professionelles Auftreten",
      "Ausgeprägte Kommunikationsstärke und Abschlussorientierung",
      "Selbstständige und strukturierte Arbeitsweise",
      "Führerschein Klasse B",
      "Begeisterung für hochwertige Fahrzeuge und Automobile",
    ],
  },
  {
    slug: "fahrer-minijob",
    title: "Fahrer (m/w/d) auf Minijob-Basis",
    employmentType: "Minijob",
    department: "Fahrzeugmanagement",
    location: "Köln",
    meta: ["Minijob", "Fahrzeugmanagement", "Köln", "Flexible Einsätze"],
    teaser: "Fahrzeugüberführungen und Fahrzeuglogistik – flexibel, verantwortungsvoll und immer unterwegs.",
    tasks: [
      "Fahrzeugabholungen und Fahrzeugüberführungen – regional und überregional",
      "Fahrten zu Geschäftspartnern, Werkstätten und Kunden",
      "Aktive Unterstützung bei unserer Fahrzeuglogistik",
      "Fahrzeugbewegungen innerhalb der MotorWorld Köln-Rheinland",
      "Übergabe und Abholung von Fahrzeugen direkt bei unseren Kunden",
      "Sichtprüfung der Fahrzeuge bei Übernahme und Übergabe",
      "Unterstützung bei Veranstaltungen und Events",
    ],
    profile: [
      "Führerschein Klasse B (zwingend erforderlich)",
      "Hohe Zuverlässigkeit und ausgeprägtes Verantwortungsbewusstsein",
      "Sorgfältiger und schonender Umgang mit hochwertigen Fahrzeugen",
      "Gepflegtes und professionelles Auftreten",
      "Flexibilität bei den Einsatzzeiten",
      "Pünktlichkeit und selbstständige Arbeitsweise",
      "Interesse an Fahrzeugen und Automobilen",
    ],
  },
  {
    slug: "aushilfe",
    title: "Aushilfe / Fahrzeuglogistik (m/w/d)",
    employmentType: "Minijob / Aushilfe",
    department: "Fahrzeugmanagement",
    location: "Köln",
    meta: ["Minijob / Aushilfe", "Fahrzeugmanagement", "Köln", "Nach Absprache"],
    teaser: "Unterstützung rund um unseren Fahrzeugbestand – organisiert, flexibel und mitten im Geschehen.",
    tasks: [
      "Unterstützung bei allen Tätigkeiten rund um unseren Fahrzeugbestand",
      "Fahrzeugbewegungen auf dem Gelände der MotorWorld",
      "Begleitung von Anlieferungen und Abholungen",
      "Allgemeine organisatorische Tätigkeiten im Tagesgeschäft",
      "Unterstützung bei der Fahrzeugpflege und -vorbereitung",
      "Mithilfe bei Veranstaltungen und Kundenterminen",
      "Ordnung und ansprechende Präsentation im Fahrzeugbereich",
    ],
    profile: [
      "Hohe Zuverlässigkeit und Flexibilität",
      "Teamfähigkeit und selbstständige Arbeitsweise",
      "Interesse an hochwertigen Fahrzeugen und Automobilen",
      "Führerschein Klasse B von Vorteil",
      "Sorgfältige und strukturierte Arbeitsweise",
      "Gepflegtes Erscheinungsbild",
    ],
  },
];
